module.exports = __webpack_public_path__ + "d24373b8ae2807ae7f374e97d8e8aaff.png";